<!-- components/BackToTop.vue -->
<template>
    <button v-show="isVisible" @click="scrollToTop" class="back-to-top" aria-label="Scroll back to the top">
      <i class="fa fa-arrow-up"></i> <!-- Font Awesome icon -->
    </button>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  let isVisible = ref(false);
  
  const THRESHOLD = 300; // The number of pixels scrolled before showing the button
  
  const handleScroll = () => {
    isVisible.value = window.scrollY > THRESHOLD;
  };
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  
  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
  });
  
  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });
  </script>
  
<style lang="scss" scoped>
@import '~/assets/constants.scss';

  .back-to-top {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    background-color: rgba($light-mode-color, 0.8); /* white with some opacity */
    color: $light-mode-background;
    border: none;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: opacity 0.3s;
    z-index: 1000; // To ensure it stays on top of other content
  }
  
  .back-to-top:hover {
    background-color: rgba($light-mode-color, 1); /* white with some opacity */
  }
  
  .back-to-top:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba($fa-orange, 0.6);
  }
  
  /* Assuming you might have a dark mode */
  .dark-mode .back-to-top {
    background-color: rgba($dark-mode-color, 0.8); /* black with some opacity */
    color: $dark-mode-background;
  }
  
  .dark-mode .back-to-top:hover {
    background-color: rgba($dark-mode-color, 1); /* black with some opacity */

  }
  </style>
  